import type {FunctionComponent} from 'react';
import {LandingSection} from '@tempo/landing';
import {Box, Flex} from '@tempo/core';
import {Image} from '@app/components/Image';

export const PartnerImage: FunctionComponent = () => {
	return (
		<Box display={{base: 'none', md: 'block'}}>
			<LandingSection height="600px" position="relative">
				<Flex flex="1">
					<Image
						alt=""
						src="d223d1f823e8897fc245da6978b6e03d.jpg"
						aspectRatio="1200/610"
						h="305px"
						w="600px"
						position="absolute"
						left="20%"
						top="100px"
					/>
					<Image
						alt=""
						src="0291769c738d67960aac84cde542030a.jpg"
						aspectRatio="1200/610"
						h="305px"
						w="600px"
						position="absolute"
						right="20%"
						bottom="40px"
					/>
				</Flex>
			</LandingSection>
		</Box>
	);
};
